'use client'

import React, { useState } from 'react'

const faqs = [
  {
    question: '¿Es seguro volar en parapente?',
    answer: '¡Absolutamente! El parapente es uno de los deportes aéreos más seguros. Nuestros pilotos cuentan con certificación FEDEAEREOS y más de 15 años de experiencia. El equipo se revisa antes de cada vuelo y contamos con seguro de vuelo incluido.'
  },
  {
    question: '¿Necesito experiencia previa?',
    answer: 'No, no necesitas ninguna experiencia previa. Nuestros vuelos son en tándem, lo que significa que volarás junto a un instructor certificado quien controla todo el vuelo. Solo tú disfruta la vista.'
  },
  {
    question: '¿Cuál es el peso máximo permitido?',
    answer: 'Peso mínimo: 20 kg. Peso máximo: 120 kg. Siempre evaluamos si en ambos extremos se puede volar de forma segura de acuerdo con las condiciones de viento del momento.'
  },
  {
    question: '¿Qué pasa si el clima no permite volar?',
    answer: 'Si las condiciones climáticas no son seguras, ofrecemos dos opciones: 1) Reprogramamos tu vuelo sin costo adicional, o 2) Devolución completa del dinero si no puedes o no deseas reprogramar. La seguridad es nuestra prioridad. Los vuelos dependen 100% del clima.'
  },
  {
    question: '¿Qué debo llevar para el vuelo?',
    answer: 'Ropa cómoda, zapatos deportivos cerrados, gafas de sol y bloqueador solar. No recomendamos faldas o vestidos. Lleva tu cámara o celular para fotos (asegurados con correa).'
  },
  {
    question: '¿Cuánto dura la experiencia completa?',
    answer: 'Los tiempos de vuelo dependen 100% de las condiciones de viento. Si en el momento las condiciones no permiten el tiempo estipulado, se hará saber al cliente antes para que sea él quién tome la decisión de volar con la posibilidad que el tiempo sea menos de lo estipulado. El vuelo dura 15-25 minutos dependiendo del paquete. La experiencia completa (instrucciones + vuelo + fotos) toma aproximadamente 1-2 horas. Debes tener disponibilidad de medio día.'
  },
  {
    question: '¿Pueden volar niños?',
    answer: 'Sí, desde los 5 años y mínimo 25 kg de peso. Para menores de 18 años se requiere presencia y autorización de un adulto.'
  },
  {
    question: '¿Incluye transporte desde Bogotá?',
    answer: 'No incluye transporte desde Bogotá, pero estamos ubicados a solo 45 minutos. Puedes llegar en vehículo particular o tomar transporte público hasta Tocancipá. Tenemos la opción de vehículos tipo camioneta que pueden recoger al cliente en Tocancipá por un valor de $40.000 COP por trayecto con cupo para 5 personas.'
  },
  {
    question: '¿Cómo hago para reservar?',
    answer: 'Puedes reservar directamente por WhatsApp al +57 302 830 9637. Requiere un abono de $20,000 COP por persona. El resto se paga el día del vuelo.'
  },
  {
    question: '¿Aceptan tarjetas de crédito?',
    answer: 'El abono se hace por transferencia. El saldo restante lo puedes pagar en efectivo o transferencia el día del vuelo. También tenemos la opción de pago con tarjeta de crédito con un cargo adicional del 5%.'
  },
  {
    question: '¿Ofrecen bonos de regalo?',
    answer: 'Sí, ofrecemos bonos de regalo. Tú escoges el plan que prefieras, haces el pago y te entregamos una tarjeta digital para que se la entregues a la persona. Los bonos digitales tienen una caducidad de un año. Si la persona no lo usa el año que se generó sino al siguiente, pueden aplicar cargos adicionales por cambio de tarifas.'
  }
]

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section className="py-20 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-4">
        {/* Título */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold font-bisteron text-white mb-4">
            Preguntas <span className="text-blue-400">Frecuentes</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Resolvemos tus dudas antes de que des el gran paso
          </p>
        </div>

        {/* FAQs */}
        <div className="max-w-4xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white/5 border border-white/10 rounded-xl overflow-hidden transition-all duration-300 hover:border-white/20"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 text-left flex items-center justify-between gap-4"
              >
                <span className="text-white font-semibold text-lg">
                  {faq.question}
                </span>
                <svg
                  className={`w-6 h-6 text-blue-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5 text-gray-300 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Final */}
        <div className="text-center mt-16">
          <p className="text-gray-400 mb-6">
            ¿Tienes más preguntas?
          </p>
          <a
            href="https://wa.me/573028309637?text=¡Hola!%20Tengo%20una%20pregunta%20sobre%20los%20vuelos%20en%20parapente"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-semibold py-4 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-green-500/25"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
            </svg>
            Hablar por WhatsApp
          </a>
        </div>
      </div>
    </section>
  )
}